/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsListAodRulesQueryResponse, AuditReportsListAodRulesQueryParams, AuditReportsListAodRules401, AuditReportsListAodRules403 } from "../models/AuditReportsListAodRules";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsListAodRules } from "../axios/auditReportsListAodRules";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsListAodRulesQueryKey = (params: AuditReportsListAodRulesQueryParams = {}) => ["api-v2", { url: '/audit-reports/v1/aod-rules' }, ...(params ? [params] : [])] as const

export type AuditReportsListAodRulesQueryKey = ReturnType<typeof auditReportsListAodRulesQueryKey>

export function auditReportsListAodRulesQueryOptions(params?: AuditReportsListAodRulesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsListAodRulesQueryKey(params)
        return queryOptions<AuditReportsListAodRulesQueryResponse, ResponseErrorConfig<AuditReportsListAodRules401 | AuditReportsListAodRules403>, AuditReportsListAodRulesQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsListAodRules(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve multiple AodRules
 * {@link /audit-reports/v1/aod-rules}
 */
export function useAuditReportsListAodRules<TData = AuditReportsListAodRulesQueryResponse, TQueryData = AuditReportsListAodRulesQueryResponse, TQueryKey extends QueryKey = AuditReportsListAodRulesQueryKey>(params?: AuditReportsListAodRulesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsListAodRulesQueryResponse, ResponseErrorConfig<AuditReportsListAodRules401 | AuditReportsListAodRules403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsListAodRulesQueryKey(params)
         

         const query = useQuery({
          ...auditReportsListAodRulesQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsListAodRules401 | AuditReportsListAodRules403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}